import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter, FaLinkedin, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
    const cities = [
        'Agra', 'Ahmedabad', 'Allahabad', 'Bangalore', 'Bhopal', 'Bhubaneswar', 'Chandigarh', 'Chennai',
        'Coimbatore', 'Dehradun', 'Delhi', 'Faridabad', 'Ghaziabad', 'Goa', 'Gurgaon', 'Guwahati',
        'Hyderabad', 'Indore', 'Jaipur', 'Kanpur', 'Kochi', 'Kolkata', 'Lucknow', 'Ludhiana',
        'Madurai', 'Mumbai', 'Nagpur', 'Nashik', 'Noida', 'Patna', 'Pune', 'Raipur',
        'Rajkot', 'Ranchi', 'Surat', 'Thane', 'Vadodara', 'Varanasi', 'Vijayawada', 'Visakhapatnam'
    ];

    return (
        <footer className="footer">
            <div className="cities-section">
                <div className="container">
                    <h3>Nationwide service across India's major cities.</h3>
                    <div className="cities-grid">
                        {cities.map((city, index) => (
                            <div key={index} className="city-item">BK Packers Movers in {city}</div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="footer-main">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-col">
                            <h4>BK Packers and Movers</h4>
                            <p>BK Packers and Movers is a reliable relocation service provider offering smooth home, office, car, and bike shifting solutions. We ensure safe, timely, and cost-effective moves with expert packing, secure transportation, and professional handling. Book with us for a stress-free relocation experience!</p>
                        </div>

                        <div className="footer-col">
                            <h4>Our Services</h4>
                            <ul>
                                <li><Link to="/services">Home Relocation</Link></li>
                                <li><Link to="/services">Office Moving</Link></li>
                                <li><Link to="/services">Packing</Link></li>
                                <li><Link to="/services">Loading</Link></li>
                                <li><Link to="/services">Unloading</Link></li>
                                <li><Link to="/services">Transportation</Link></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Navigation</h4>
                            <ul>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/services">Services</Link></li>
                                <li><Link to="/testimonials">Testimonials</Link></li>
                                <li><a href="https://wa.me/918189999775" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Get In Touch</h4>
                            <div className="contact-item">
                                <FaMapMarkerAlt />
                                <span>Aringar Anna Nagar, 2nd Street, Neelangarai, ECR,Chennai - 600115</span>
                            </div>
                            <div className="contact-item">
                                <FaEnvelope />
                                <span>info@bkpackers.com</span>
                            </div>
                            <div className="contact-item">
                                <FaPhone />
                                <span>+91 81899 99775</span>
                            </div>
                            <div className="social-icons">
                                <span>Follow Us:</span>
                                <div className="icons">
                                    <a href="#"><FaFacebook /></a>
                                    <a href="#"><FaInstagram /></a>
                                    <a href="#"><FaYoutube /></a>
                                    <a href="#"><FaTwitter /></a>
                                    <a href="#"><FaLinkedin /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <p>© 2026 BK Packers and Movers. All rights reserved.</p>
                    <p style={{ fontSize: "12px", color: "#aaa" }}>
                        Site by
                        <a
                            href="https://github.com/j25praveenkumar"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#aaa" }}
                        >
                            Praveenkumar
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
